import classNames from 'classnames';

import Typography, { TypographyProps } from './Typography';

import styles from '../../styles/typography/card-title.module.css';

function CardTitleTypography({ className = null, ...props }: TypographyProps) {
    return <Typography tag="h4" className={classNames([styles.container, className])} {...props} />;
}

export default CardTitleTypography;
